exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indent[data-v-3362446c]{padding-left:1rem}.js-tree-brackets[data-v-3362446c]{cursor:pointer}.js-tree-brackets[data-v-3362446c]:hover{color:var(--fts-primary)}.js-comment[data-v-3362446c]{color:#2e7d32}.js-value[data-v-3362446c]{word-break:break-word}.js-value.js-value--boolean[data-v-3362446c],.js-value.js-value--number[data-v-3362446c]{color:#1d8ce0}.js-value.js-value--string[data-v-3362446c]{color:#13ce66}.js-value.js-value--null[data-v-3362446c],.js-value.js-value--undefined[data-v-3362446c]{color:#d55fde}", ""]);

// exports
